/*
  Cart-Upsell Peek-Toggle — klappt den 1,5-Zeilen-Drawer-Upsell auf/zu.
  Delegierter Click auf document (überlebt das Drawer-Re-Render bei Cart-Change).
  Toggelt `is-expanded` auf dem nächsten `.t-cart-upsell` und swappt Button-Text/aria.
*/
(function () {
  'use strict';
  function onClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cart-upsell-peek-toggle]') : null;
    if (!btn) return;
    var box = btn.closest('.t-cart-upsell');
    if (!box) return;
    var expanded = box.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.textContent = expanded ? '▸ weniger anzeigen' : '▸ mehr anzeigen';
  }
  if (document && document.addEventListener) {
    document.addEventListener('click', onClick);
  }
})();
